import { render, staticRenderFns } from "./CashStatement-us.vue?vue&type=template&id=80b247ca&scoped=true"
import script from "./CashStatement-us.vue?vue&type=script&lang=js"
export * from "./CashStatement-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b247ca",
  null
  
)

export default component.exports